/** Identificadores fijos mapeados a íconos Serenity en el frontend. */
export const COUNTING_ITEM_TYPES = [
  'apple',
  'pencil',
  'star',
  'car',
  'ball',
  'flower',
  'block',
  'coin',
  'heart',
  'leaf',
] as const;

export type CountingItemType = (typeof COUNTING_ITEM_TYPES)[number];

export interface CountingCollectionGroup {
  id: string;
  itemType: CountingItemType;
  /** Cantidad visual de íconos — debe ser múltiplo de `step` cuando aplica. */
  count: number;
  /** Etiqueta opcional de escena (ej. "Salto 1") — NO se usa para el casillero de respuesta. */
  label?: string;
}

export interface CountingCollectionPayload {
  instruction: string;
  /** Tamaño del salto de conteo (2, 5…) — alinea counts con la metáfora. */
  step?: number;
  groups: CountingCollectionGroup[];
}

export interface CountingCollectionRuntime {
  viewed: boolean;
  /** Respuestas por group.id */
  answers?: Record<string, string>;
}
